import tw from "twin.macro";
import { SideMenuContentPadding } from "@containers/side-menu-content-padding";
import { css } from "@styled-system/css";
import { flex } from "@styled-system/patterns";

export const Wrapper = tw(SideMenuContentPadding)`
	min-h-full
	flex
	flex-col
	items-center
	justify-center
`;

export const placeholderWrapperClass = css({
	width: "full",
	md: {
		width: "1/3",
	},
});
export const wrapperClass = flex({
	width: "full",
	minHeight: "full",
	flexDir: "column",
	alignItems: "center",
	justifyContent: "center",
	padding: "24",
});
